import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NextrayModel } from '@ortho-next/nextray-core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../app-config';
import { IIntegrationRepository } from './Iintegration.repository';
import { ApiResponse } from './models';


@Injectable({ providedIn: 'root' })
export class IntegrationRepository implements IIntegrationRepository {

	private readonly config = inject(APP_CONFIG);
	private readonly httpClient = inject(HttpClient);


	getJPSModel(caseId: string, userId: string): Observable<ApiResponse<NextrayModel>> {
		const params = new HttpParams().set('userId', userId);
		return this.httpClient.get<ApiResponse<NextrayModel>>(this.config.domainIntegrationAPI + `/api/model/Jps/${caseId}`, { params });
	}
}
